import { i18nKeys } from 'translationTypes'
import i18n from '../../../../i18n'

export default {
  title: () => i18n.t(i18nKeys.bankOnboardingSplash__verifyAddress__title),
  primaryAction: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__verifyAddress__primaryAction),
  searchPlaceholder: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__verifyAddress__searchPlaceholder),
  addressError: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__verifyAddress__addressError),
}
